import { render, staticRenderFns } from "./MarketplaceApi.vue?vue&type=template&id=7e63a3d6"
import script from "./MarketplaceApi.vue?vue&type=script&lang=js"
export * from "./MarketplaceApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports